import useFetch from '@hooks/useFetch';

export const getKey = (batchUID) => `v1/batch/${batchUID}/trial_classes/`;

const useBatchTrialClasses = (batchUID) => {
  const key = getKey(batchUID);

  const { data: trialClasses, ...rest } = useFetch(batchUID ? key : null);

  return { key, trialClasses, ...rest };
};

export default useBatchTrialClasses;
